export default __webpack_public_path__ + "static/media/nodejs.c598e70d.ico";